import React from 'react';
import { Link } from 'react-router-dom';

const ContactUs = () => {
  const whatsappNumber = "31614359710"; // Format: country code + number without +
  const phoneNumber = "+31 6 14 35 97 10";

  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/${whatsappNumber}`, '_blank');
  };

  const handlePhoneCall = () => {
    window.location.href = `tel:${phoneNumber}`;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-orange-50">
      {/* Back Button */}
      <div className="container mx-auto px-4 pt-8 pb-4">
        <Link
          to="/"
          className="inline-flex items-center space-x-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-800 text-white font-semibold rounded-xl hover:from-blue-700 hover:to-blue-900 transition-all duration-300 shadow-lg hover:shadow-xl"
        >
          <i className="fas fa-arrow-left"></i>
          <span>Back</span>
        </Link>
      </div>

      {/* Hero Section with Rotterdam Theme */}
      <section className="relative py-16 px-4">
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <div className="w-20 h-20 bg-gradient-to-r from-blue-600 to-orange-500 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-xl">
              <i className="fas fa-map-marker-alt text-white text-3xl"></i>
            </div>
            <h1 className="text-5xl font-bold mb-4 bg-gradient-to-r from-blue-600 to-orange-500 bg-clip-text text-transparent">
              Contact Us
            </h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Visit us in Rotterdam or get in touch via WhatsApp
            </p>
          </div>
        </div>
      </section>

      {/* Contact Information Cards */}
      <section className="py-12 px-4">
        <div className="container mx-auto max-w-6xl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            
            {/* Address Card */}
            <div className="bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-300 border-2 border-blue-100">
              <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-2xl flex items-center justify-center mb-6">
                <i className="fas fa-store text-white text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Our Location</h3>
              <div className="space-y-3 text-gray-600">
                <p className="flex items-start">
                  <i className="fas fa-map-marker-alt text-red-500 mt-1 mr-3"></i>
                  <span className="text-lg">
                    <strong>Schiedamseweg 159A</strong><br/>
                    3026 AK Rotterdam<br/>
                    Netherlands
                  </span>
                </p>
              </div>
            </div>

            {/* WhatsApp Card */}
            <div className="bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-300 border-2 border-green-100">
              <div className="w-16 h-16 bg-gradient-to-r from-green-500 to-emerald-600 rounded-2xl flex items-center justify-center mb-6">
                <i className="fab fa-whatsapp text-white text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Contact Support</h3>
              <div className="space-y-4">
                <p className="text-gray-600 mb-6">
                  Have questions? Need assistance? Contact us via WhatsApp or phone for quick responses.
                </p>
                
                {/* WhatsApp Button */}
                <button
                  onClick={handleWhatsAppClick}
                  className="w-full flex items-center justify-center space-x-3 px-8 py-4 bg-gradient-to-r from-green-500 to-emerald-600 text-white text-lg font-bold rounded-2xl hover:from-green-600 hover:to-emerald-700 transform hover:scale-105 transition-all duration-300 shadow-lg"
                >
                  <i className="fab fa-whatsapp text-2xl"></i>
                  <span>Chat on WhatsApp</span>
                </button>
                
                {/* Phone Button */}
                <button
                  onClick={handlePhoneCall}
                  className="w-full flex items-center justify-center space-x-3 px-8 py-4 bg-gradient-to-r from-blue-500 to-indigo-600 text-white text-lg font-bold rounded-2xl hover:from-blue-600 hover:to-indigo-700 transform hover:scale-105 transition-all duration-300 shadow-lg"
                >
                  <i className="fas fa-phone text-2xl"></i>
                  <span>Call Us</span>
                </button>
                
                <p className="text-sm text-gray-500 text-center mt-2">
                  📱 {phoneNumber}
                </p>
              </div>
            </div>
          </div>

          {/* Google Maps Embed */}
          <div className="bg-white rounded-3xl p-4 shadow-xl">
            <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">Find Us on the Map</h3>
            <div className="w-full h-96 rounded-2xl overflow-hidden">
              <iframe
                title="Ashop Rotterdam Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2460.824!2d4.4691!3d51.9196!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c433a3b0c6e7b5%3A0x0!2sSchiedamseweg%20159A%2C%203026%20AK%20Rotterdam!5e0!3m2!1sen!2snl!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>

          {/* Business Hours Section */}
          <div className="mt-12 bg-gradient-to-r from-blue-600 to-orange-500 rounded-3xl p-8 text-white text-center shadow-xl">
            <h3 className="text-3xl font-bold mb-4">Visit Ashop Rotterdam</h3>
            <p className="text-xl mb-2">Your One-Stop Shop in the Heart of Rotterdam</p>
            <p className="text-lg opacity-90">
              <i className="fas fa-store mr-2"></i>
              Package Management • Money Transfer • Mobile Phones • Printing • Travel • SIM Cards
            </p>
          </div>
        </div>
      </section>

      {/* Rotterdam Maritime Theme Footer Element */}
      <section className="py-8">
        <div className="container mx-auto text-center">
          <div className="flex items-center justify-center space-x-4 text-gray-600">
            <i className="fas fa-ship text-blue-600 text-2xl"></i>
            <span className="text-lg font-semibold">Proudly Serving Rotterdam</span>
            <i className="fas fa-anchor text-orange-500 text-2xl"></i>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUs;
